import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import FormInputLabel from './form-input-label';
import TranslatedCopy from '../../intl/translated-copy';

const mapStateToProps = state => {
  return {
    languageBundle: state.LanguageBundle.languageBundle,
    helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
  };
};

class FormInputDropdownNew extends Component {
  static defaultProps = {
    autoFocusInput: false,
    hasLabelTooltip: false,
    isClearable: false,
    isDisabled: false,
    isHidden: false,
    isRequired: false,
    placeholderCopyID: 'APP_SELECT',
    shouldSetErrorWidth: false,
    validateNoSpecialCharsOnChange: false,
    showIcon: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      seleted: {
        value: 'default',
        copyID: 'default',
      },
      open: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    const { options } = this.props;
    this.setState({
      seleted: {
        value: options[0].value,
        copyID: options[0].copyID,
      },
    });
  }
  componentWillUnmount() {
    this.setState({
      open: false,
    });
  }

  render() {
    const {
      className,
      input: { name },
      isRequired,
      label,
      labelCopyID,
      labelClassModifier,
      options,
    } = this.props;

    const { seleted, open } = this.state;

    const valueClasses = cx({
      'FormInputDropdown-value': true,
    });
    const containerDropdown = cx({
      'FormInputDropdown-wrapper': true,
      'selected': open,
    });
    const optionalClass = cx({
      // 'Label-Dropdown': true,
      'open': open,
    });
    const icon = cx({
      'FormInputDropdown-icon': true,
      'Icon Icon--arrowSmallDown': !open,
      'Icon Icon--arrowSmallUp': open,
    });

    return (
      <div onClick= { this.handleClick } tabIndex='1'
        onBlur={ this.handleClose }>
        <FormInputLabel
          optionalClass={ optionalClass }
          name={ name }
          isRequired={ isRequired }
          label={ label }
          labelClassModifier={ labelClassModifier }
          labelCopyID={ labelCopyID } />
        <div className={ containerDropdown }>
          <div className='FormInputDropdown-listTrigger'>
            <span className={ valueClasses }>
              <TranslatedCopy copyID={ seleted.copyID } />
            </span>
            <span className={ icon } />
          </div>
        </div>
        { open ? <div className={`Dropdown-options ${className}`}>
          <ul>
            { options.map((op, index) => {
              return (<li onClick={ () => this.handleChange(op.value, op.copyID) } id={ op.value }
                key= { index }>
                <TranslatedCopy copyID={ op.copyID}/>
              </li>);
            })}
          </ul>
        </div> : null}
      </div>
    );
  }

  handleChange(value, copyID) {
    const { changeValue } = this.props;
    const { seleted } = this.state;
    if (copyID !== seleted.copyID) {
      if (value === 'Reservation' || value === 'Program_frecuent_traveler') {
        changeValue('MENU_MY_TRIPS', 'reservationType', value);
      } else {
        changeValue('MENU_MY_TRIPS', 'programFrequentTraveler', value);
      }
      this.setState({
        seleted: {
          value,
          copyID,
        },
      });
    }
    this.setState({
      open: false,
    });
  }

  handleClick() {
    const { open } = this.state;

    this.setState({
      open: !open,
    });
  }

  handleClose() {
    this.setState({
      open: false,
    });
  }
} 

FormInputDropdownNew = connect(mapStateToProps)(FormInputDropdownNew);

export default injectIntl(FormInputDropdownNew);
